import { useScrollAnimation } from "@/hooks/useScrollAnimation";

export function AboutUs() {
  const { ref: leftRef, isVisible: leftVisible } = useScrollAnimation();
  const { ref: rightRef, isVisible: rightVisible } = useScrollAnimation();

  return (
    <section id="sobre" className="py-16 sm:py-24 bg-gradient-to-b from-background via-muted/20 to-background text-foreground transition-colors duration-300">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          <div
            ref={leftRef}
            className={`lg:w-1/2 transition-all duration-700 ${
              leftVisible ? "opacity-100 lg:translate-x-0" : "opacity-0 lg:-translate-x-10"
            }`}
          >
            <img
              alt="Equipe K-recão Lanches"
              src="/lovable-uploads/3917bd94-56ee-422b-8d4d-10072c509f3b.png"
              className="rounded-lg shadow-2xl w-full h-64 sm:h-80 lg:h-[400px] object-contain"
            />
          </div>

          <div
            ref={rightRef}
            className={`lg:w-1/2 transition-all duration-700 delay-200 ${
              rightVisible ? "opacity-100 lg:translate-x-0" : "opacity-0 lg:translate-x-10"
            }`}
          >
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-950 dark:text-white mb-6">
              Sobre o <span className="text-krecao-red">K-recão</span>{" "}
              <span className="text-amber-600 dark:text-krecao-yellow">Lanches</span>
            </h2>

            <div className="w-20 h-1 bg-amber-500 dark:bg-krecao-yellow mb-6" />

            <p className="text-gray-800 dark:text-gray-200 mb-6 font-normal text-sm sm:text-base">
              Desde 2006, o{" "}
              <span className="text-amber-600 dark:text-krecao-yellow font-bold">K-recão Lanches</span> tem
              se dedicado a oferecer os melhores hambúrgueres e lanches da cidade. Nossa
              paixão pela gastronomia e compromisso com a qualidade nos tornaram referência
              quando o assunto é hambúrguer artesanal.
            </p>

            <p className="text-gray-800 dark:text-gray-200 mb-6 text-sm sm:text-base">
              Utilizamos apenas ingredientes selecionados e receitas exclusivas para garantir
              uma experiência única aos nossos clientes. Cada hambúrguer é preparado na hora,
              com carinho e dedicação por nossa equipe de profissionais.
            </p>

            <p className="text-gray-800 dark:text-gray-200 mb-6 text-sm sm:text-base">
              Nossa equipe é formada por especialistas apaixonados pela culinária, sempre
              prontos para preparar os melhores lanches para você e sua família.
            </p>

            <p className="text-gray-900 dark:text-gray-100 font-semibold text-sm sm:text-base">
              Venha conhecer o <span className="text-krecao-red">K-recão Lanches</span> e
              descubra por que somos a escolha preferida dos amantes de boa comida!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
